import Card from '@/components/Card';
import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import {
  AppWindow,
  BookUser,
  ChevronsLeftRightEllipsis,
  Hash,
  Server,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { InfoBox, InfoContainer } from './styles';

interface ServerStatsProps {
  serverIPv4?: string;
  metrics?: {
    system: {
      name: string;
      version: string;
      architecture: string;
    };
  };
}

function ServerStats({ serverIPv4, metrics }: ServerStatsProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Card width="100%">
      <InfoBox>
        <Server size="18px" />
        <Typography variant="h4">{t('dashboard.server')}</Typography>
      </InfoBox>
      <InfoContainer>
        <InfoBox>
          <ChevronsLeftRightEllipsis size="16px" />
          <Typography variant="caption">IPV4: </Typography>
          <Typography variant="caption" color={theme.palette.white['06']}>
            {serverIPv4}
          </Typography>
        </InfoBox>

        <InfoBox>
          <AppWindow size="14px" />
          <Typography variant="caption">
            {t('dashboard.system') + ' '}{' '}
          </Typography>
          <Typography variant="caption" color={theme.palette.white['06']}>
            {metrics?.system.name}
          </Typography>
        </InfoBox>

        <InfoBox>
          <Hash size="14px" />
          <Typography variant="caption">{t('dashboard.version')} </Typography>
          <Typography variant="caption" color={theme.palette.white['06']}>
            {metrics?.system.version}
          </Typography>
        </InfoBox>

        <InfoBox>
          <BookUser size="14px" />
          <Typography variant="caption">
            {t('dashboard.architecture')}{' '}
          </Typography>
          <Typography variant="caption" color={theme.palette.white['06']}>
            {metrics?.system.architecture}
          </Typography>
        </InfoBox>
      </InfoContainer>
    </Card>
  );
}

export default ServerStats;
